import React from 'react'
import { Button } from '@mui/material'
import type { PickersActionBarProps } from '@mui/x-date-pickers'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { ActionButtonsContainer } from './styles'

const DayPickerActionButtons: React.FC<PickersActionBarProps> = ({ onAccept, onCancel }) => {
  const { t } = useFavurTranslation()

  return (
    <ActionButtonsContainer>
      <Button onClick={onCancel} color="secondary" data-testid="datepicker-cancel">
        {t('datePicker.button.cancel')}
      </Button>
      <Button onClick={onAccept} color="secondary" variant="contained" data-testid="datepicker-ok">
        {t('datePicker.button.ok')}
      </Button>
    </ActionButtonsContainer>
  )
}

export default DayPickerActionButtons
